export type PlatformReviewItem = {
  platform: string
  rating: number
  maxRating: number
  link?: string
}

export const DEFAULT_PLATFORM_REVIEWS: readonly [
  PlatformReviewItem,
  PlatformReviewItem,
  PlatformReviewItem,
] = [
  {
    platform: 'G2 Crowd',
    rating: 4.6,
    maxRating: 5,
    link: 'https://www.g2.com/products/slite/reviews',
  },
  {
    platform: 'Capterra',
    rating: 4.7,
    maxRating: 5,
    link: 'https://www.capterra.com/p/173815/Slite/',
  },
  {
    platform: 'Product Hunt',
    rating: 4.8,
    maxRating: 5,
    link: 'https://www.producthunt.com/products/slite',
  },
]
